import { createBrowserRouter } from "react-router-dom";
import MainPage from "../pages/MainPage";
import Contact from "../pages/Contact";
import AboutUs from "../pages/AboutUs";
import Projects from "../pages/Projects";
import FilmDetails from "../pages/FilmDetails";
import Tracak from "../pages/Tracak";
import ContentCreator from "../pages/ContentCreator";
import Whoops from "../pages/Whoops";
import Mail from "../pages/Mail";
import Chats from "../pages/Chats";
import Deepfake from "../pages/Deepfake";
import InstagramMobile from "../pages/InstagramMobile";
import InstagramMobileVukJanko from "../pages/InstagramMobileVukJanko";
import InstagramMobileVJ from "../pages/InstagramMobileVJ";
import Clanak from "../pages/Clanak";
import Mapa1 from "../pages/Mapa1";
import Grafikon from "../pages/Grafikon";
import Notifications from "../pages/Notifications";
import LivePage from "../pages/LivePage";
import PgReal from "../pages/PgReal";
import Notifications2 from "../pages/Notifications2";
import Notifications3 from "../pages/Notifications3";
import Notifications4 from "../pages/Notifications4";
import LivePage2 from "../pages/LivePage2";
import IsonTube from "../pages/IsonTube";
import IsonTube2 from "../pages/IsonTube2";
import EmailLocator from "../pages/EmailLocator";
import InstagramDesktopVJ from "../pages/InstagramDesktopVJ";
import InstagramDesktopVukJanko from "../pages/InstagramDesktopVukJanko";
import InstagramDesktopMarija from "../pages/InstagramDesktopMarija";
import Mail1 from "../pages/Mail1";
import Mail2 from "../pages/Mail2";
import Mail4 from "../pages/Mail4";
import Mail5 from "../pages/Mail5";

export const ERoutes = {
  MainPage: "/",
  AboutUs: "/about-us",
  Contact: "/contact",
  Projects: "/projects",
  BrandVideoMusic: "/brand-video-music",
  ContentCreator: "/content-development",
  MFP: "/mfp",
  Tracak: "/tracak",
  Whoops: "/whoops",
  Mail1: "/mail1",
  Mail2: "/mail2",
  Mail3: "/mail3",
  Mail4: "/mail4",
  Mail5: "/mail5",
  Mapa1: "/mapa1",
  Mapa2: "/mapa2",
  Mapa3: "/mapa3",
  Mapa4: "/mapa4",
  Chat: "/chat",
  LivePage: "/live",
  LivePage2: "/live2",

  Reel: "/reel",

  Grafikon: "/grafikon",
  Notifikacije: "/notifikacije",
  Notifikacije2: "/notifikacije2",
  Notifikacije3: "/notifikacije3",
  Notifikacije4: "/notifikacije4",
  IsonTube: "/lofi",
  IsonTube2: "/deepfake-video",
  EmailLocator: "/vpn-tracker",

  InstagramMobileMarija: "/facegram-phone/marija",
  InstagramMobileVukJanko: "/facegram-phone/vuk-janko",
  InstagramMobileVJ: "/facegram-phone/mr-wolf",
  InstagramDesktopMarija: "/facegram/marija",
  InstagramDesktopVukJanko: "/facegram/vuk-janko",

  InstagramDesktopVJ: "/facegram/mr-wolf",

  Detektor: "/detektor",
  Clanak: "/clanak",
  Anything: "*",
};

export const router = createBrowserRouter([
  { path: ERoutes.MainPage, element: <MainPage /> },
  { path: ERoutes.AboutUs, element: <AboutUs /> },
  { path: ERoutes.Contact, element: <Contact /> },
  { path: ERoutes.Projects, element: <Projects propsIsFilm={true} /> },
  { path: ERoutes.BrandVideoMusic, element: <Projects propsIsFilm={false} /> },
  { path: ERoutes.MFP, element: <FilmDetails /> },
  { path: ERoutes.Tracak, element: <Tracak /> },
  { path: ERoutes.Whoops, element: <Whoops /> },
  { path: ERoutes.ContentCreator, element: <ContentCreator /> },
  { path: ERoutes.Mail1, element: <Mail1 /> },
  { path: ERoutes.Mail2, element: <Mail /> },
  { path: ERoutes.Mail3, element: <Mail2 /> },
  { path: ERoutes.Mail4, element: <Mail4 /> },
  { path: ERoutes.Mail5, element: <Mail5 /> },
  { path: ERoutes.Detektor, element: <Deepfake /> },
  { path: ERoutes.Clanak, element: <Clanak /> },
  { path: ERoutes.LivePage, element: <LivePage /> },
  { path: ERoutes.LivePage2, element: <LivePage2 /> },
  { path: ERoutes.IsonTube, element: <IsonTube /> },
  { path: ERoutes.IsonTube2, element: <IsonTube2 /> },
  { path: ERoutes.EmailLocator, element: <EmailLocator /> },

  { path: ERoutes.Reel, element: <PgReal /> },

  { path: ERoutes.Grafikon, element: <Grafikon /> },
  { path: ERoutes.Notifikacije, element: <Notifications /> },
  { path: ERoutes.Notifikacije2, element: <Notifications2 /> },
  { path: ERoutes.Notifikacije3, element: <Notifications3 /> },
  { path: ERoutes.Notifikacije4, element: <Notifications4 /> },

  { path: ERoutes.Mapa1, element: <Mapa1 redniBroj={1} /> },
  { path: ERoutes.Mapa2, element: <Mapa1 redniBroj={2} /> },
  { path: ERoutes.Mapa3, element: <Mapa1 redniBroj={3} /> },
  { path: ERoutes.Mapa4, element: <Mapa1 redniBroj={4} /> },
  { path: ERoutes.InstagramMobileMarija, element: <InstagramMobile /> },
  { path: ERoutes.InstagramDesktopMarija, element: <InstagramDesktopMarija /> },

  {
    path: ERoutes.InstagramMobileVukJanko,
    element: <InstagramMobileVukJanko />,
  },
  {
    path: ERoutes.InstagramDesktopVukJanko,
    element: <InstagramDesktopVukJanko />,
  },
  {
    path: ERoutes.InstagramMobileVJ,
    element: <InstagramMobileVJ />,
  },
  {
    path: ERoutes.InstagramDesktopVJ,
    element: <InstagramDesktopVJ />,
  },

  { path: ERoutes.Chat, element: <Chats /> },

  { path: ERoutes.Anything, element: <MainPage /> },
]);
